(function() {
  var currencySymbols = {
    // Americas
    'USD': 'US$',
    'CAD': 'CA$',
    'MXN': 'MX$',
    'BRL': 'R$',
    'ARS': 'AR$',
    'CLP': 'CL$',
    'COP': 'CO$',
    'PEN': 'S/',
    'UYU': '$U',
    'BOB': 'Bs.',
    'PYG': '₲',
    'VES': 'Bs.S',
    'GTQ': 'Q',
    'HNL': 'L',
    'NIO': 'C$',
    'CRC': '₡',
    'PAB': 'B/.',
    'DOP': 'RD$',
    'JMD': 'J$',
    'TTD': 'TT$',
    'BBD': 'Bds$',
    'BSD': 'B$',
    'BZD': 'BZ$',
    'GYD': 'G$',
    'SRD': 'Sr$',
    'HTG': 'G',
    'AWG': 'ƒ',
    'ANG': 'ƒ',

    // Europe
    'EUR': '€',
    'GBP': '£',
    'CHF': 'CHF',
    'NOK': 'kr',
    'SEK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RON': 'lei',
    'BGN': 'лв',
    'HRK': 'kn',
    'RSD': 'din',
    'BAM': 'KM',
    'MKD': 'ден',
    'ALL': 'L',
    'ISK': 'kr',
    'UAH': '₴',
    'RUB': '₽',
    'GEL': '₾',
    'AMD': '֏',
    'AZN': '₼',
    'MDL': 'L',
    'BYN': 'Br',
    'TRY': '₺',

    // Asia Pacific
    'JPY': '¥',
    'CNY': 'CN¥',
    'HKD': 'HK$',
    'TWD': 'NT$',
    'KRW': '₩',
    'SGD': 'SG$',
    'AUD': 'AU$',
    'NZD': 'NZ$',
    'MYR': 'RM',
    'THB': '฿',
    'IDR': 'Rp',
    'PHP': '₱',
    'VND': '₫',
    'INR': '₹',
    'PKR': '₨',
    'BDT': '৳',
    'LKR': 'Rs',
    'NPR': 'Rs',
    'MMK': 'K',
    'KHR': '៛',
    'LAK': '₭',
    'MNT': '₮',
    'MOP': 'MOP$',
    'BND': 'B$',
    'FJD': 'FJ$',
    'PGK': 'K',
    'WST': 'T',
    'TOP': 'T$',
    'SBD': 'SI$',
    'VUV': 'Vt',

    // Middle East & Africa
    'AED': 'د.إ',
    'SAR': '﷼',
    'QAR': '﷼',
    'KWD': 'د.ك',
    'BHD': 'BD',
    'OMR': '﷼',
    'JOD': 'JD',
    'ILS': '₪',
    'EGP': 'E£',
    'MAD': 'MAD',
    'TND': 'DT',
    'DZD': 'DA',
    'LYD': 'LD',
    'ZAR': 'R',
    'NGN': '₦',
    'GHS': '₵',
    'KES': 'KSh',
    'UGX': 'USh',
    'TZS': 'TSh',
    'ETB': 'Br',
    'XOF': 'CFA',
    'XAF': 'FCFA',
    'MUR': 'Rs',
    'MZN': 'MT',
    'AOA': 'Kz',
    'ZMW': 'ZK',
    'BWP': 'P',
    'NAD': 'N$',
    'SZL': 'L',
    'LSL': 'L',
    'RWF': 'RF',
    'DJF': 'Fdj',
    'SCR': 'Rs',
    'MGA': 'Ar',
    'MWK': 'MK',
    'GMD': 'D',
    'SLL': 'Le',
    'GNF': 'FG',
    'LRD': 'L$',
    'CVE': '$',
    'STN': 'Db',
    'KMF': 'CF',
    'ERN': 'Nfk',
    'SDG': 'ج.س',
    'SOS': 'Sh',
    'BIF': 'Fr',
    'CDF': 'Fr',

    // Central Asia
    'KZT': '₸',
    'UZS': 'so\'m',
    'KGS': 'с',
    'TJS': 'SM',
    'TMT': 'T',
    'AFN': '؋',
    'IRR': '﷼',
    'IQD': 'ع.د',
    'SYP': '£',
    'LBP': 'L£',
    'YER': '﷼'
  };

  // Shared function to fix symbol on a single text node
  function fixTextNode(node, symbol) {
    if (node.nodeType === 3) {
      node.textContent = node.textContent.replace(
        /^\s*([A-Z]{2,3}\s?)?([^\d\s,\.]+)/,
        symbol
      );
    }
  }

  // Fix all .money elements
function fixMoneyEl(el, symbol) {
  el.childNodes.forEach(function(node) {
    if (node.nodeType === 3) {
      // Direct text node
      fixTextNode(node, symbol);
    } else if (node.nodeType === 1) {
      // Element node — recurse into it
      fixMoneyEl(node, symbol);
    }
  });
}


  function updateSymbols() {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!currency || !currencySymbols[currency]) return;
    var symbol = currencySymbols[currency];
    document.querySelectorAll('.money, .sale-price, .discount--line-through, .cart-drawer__product-card--price--compare, .cart-drawer__product-card--price--sale, .cart-drawer__product-card--price, .product-grid--price-font-body, .cart-drawer__subtotal--compare, .cart-drawer__subtotal--sale, .cart-drawer__subtotal--price')
.forEach(function(el) {
      fixMoneyEl(el, symbol);
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', updateSymbols);

  // Run on variant change
  document.addEventListener('variant:changed', updateSymbols);
  document.addEventListener('price:updated', updateSymbols);

  // MutationObserver for dynamic DOM updates
  var observer = new MutationObserver(function(mutations) {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!currency || !currencySymbols[currency]) return;
    var symbol = currencySymbols[currency];

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('money')) {
            fixMoneyEl(node, symbol);
          }
          node.querySelectorAll && node.querySelectorAll('.money, .sale-price, .discount--line-through, .cart-drawer__product-card--price--compare, .cart-drawer__product-card--price--sale, .cart-drawer__product-card--price, .product-grid--price-font-body, .cart-drawer__subtotal--compare, .cart-drawer__subtotal--sale, .cart-drawer__subtotal--price')
.forEach(function(el) {
            fixMoneyEl(el, symbol);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
